import { useTranslation } from 'react-i18next'
import clsx from 'clsx'

import { SimpleInput } from '@makyoapp/makyo-ui'

export interface SearchFieldProps {
  search: string
  setSearch: (value: string) => void
  id?: string
  className?: string
  placeholder?: string
  inputClassName?: string
  noBorder?: boolean
}

export function SearchField({
  search,
  setSearch,
  id = 'data-search-input',
  className,
  placeholder,
  inputClassName = 'w-full! txt',
  noBorder = false,
}: SearchFieldProps) {
  const { t } = useTranslation()

  return (
    <div
      className={clsx('component-filter border-b border-b-gray-300 dark:border-b-gray-600', className, {
        'border-b-0': noBorder,
      })}
    >
      <div className='component-search w-full'>
        <SimpleInput
          id={id}
          onChange={(e) => {
            setSearch(e.currentTarget.value)
          }}
          inputClassName={inputClassName}
          placeholder={placeholder || t('Search')}
          outlined
          value={search}
          showClear={Boolean(search)}
          onClear={() => setSearch('')}
        />
      </div>
    </div>
  )
}
